import { FieldState, FormState } from 'formstate'
import {
  DailyMenuLogoSizeTypeEnum,
  DailyMenuTemplateEnum,
  SoupPricingTypeEnum,
} from '../../../../__generated__/graphql'
import { sanitizeHtmlOutput } from '../../../utils/forms/inputHelpers'

export class StoreDailyMenuSettingsForm {
  title = new FieldState<string>('').validators()
  restaurantName = new FieldState<string>('').validators()
  currencyId = new FieldState<string>('').validators()
  description = new FieldState<string>('').validators()
  bottomDescription = new FieldState<string>('').validators()
  template = new FieldState<DailyMenuTemplateEnum>(
    DailyMenuTemplateEnum.White
  ).validators()
  from = new FieldState<string>('').validators()
  to = new FieldState<string>('').validators()
  logo = new FieldState<File | null>(null).validators()
  logoSizeType = new FieldState<DailyMenuLogoSizeTypeEnum>(
    DailyMenuLogoSizeTypeEnum.Large
  ).validators()
  image = new FieldState<File | null>(null).validators()
  price = new FieldState<string>('').validators()
  soupPricedInMainDish = new FieldState<boolean>(false).validators()
  soupCanBeOrderedSeparately = new FieldState<boolean>(false).validators()
  soupPricingType = new FieldState<SoupPricingTypeEnum>(
    SoupPricingTypeEnum.SeparatedFromMainDish
  ).validators()
  showRestaurantName = new FieldState<boolean>(false).validators()
  showAllergens = new FieldState<boolean>(false).validators()
  showPortionSize = new FieldState<boolean>(false).validators()
  publishedAt = new FieldState<string>('').validators()

  form = new FormState([
    this.title,
    this.restaurantName,
    this.currencyId,
    this.description,
    this.bottomDescription,
    this.from,
    this.to,
    this.template,
    this.price,
    this.soupPricedInMainDish,
    this.soupCanBeOrderedSeparately,
    this.soupPricingType,
    this.showRestaurantName,
    this.showAllergens,
    this.showPortionSize,
    this.publishedAt,
    this.logoSizeType,
  ])

  serialize = async () => {
    const res = await this.form.validate()

    return res.hasError
      ? null
      : {
          title: this.title.$,
          restaurantName: this.restaurantName.$,
          description: this.description.$
            ? sanitizeHtmlOutput(this.description.$)
            : '',
          bottomDescription: this.bottomDescription.$
            ? sanitizeHtmlOutput(this.bottomDescription.$)
            : '',
          currencyId: this.currencyId.$ ?? 1,
          template: this.template.$,
          from: this.from.$,
          to: this.to.$,
          logo: this.logo.$ ?? null,
          image: this.image.$,
          soupPricedInMainDish: this.soupPricedInMainDish.$,
          soupCanBeOrderedSeparately: this.soupCanBeOrderedSeparately.$,
          soupPricingType: this.soupPricingType.$,
          showRestaurantName: this.showRestaurantName.$,
          showAllergens: this.showAllergens.$,
          showPortionSize: this.showPortionSize.$,
          publishedAt: this.publishedAt.$,
          logoSizeType: this.logoSizeType.$,
        }
  }
}
